export default __webpack_public_path__ + "static/media/prm-logo.a9d089d6.png";